import { render } from "./create_template_data.vue?vue&type=template&id=49f84fb8&scoped=true"
import script from "./create_template_data.vue?vue&type=script&lang=js"
export * from "./create_template_data.vue?vue&type=script&lang=js"

import "./create_template_data.vue?vue&type=style&index=0&id=49f84fb8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f84fb8"]])

export default __exports__